import { BRAND_WOWCHER } from '../setup/setup';
import {
  DEALS,
  ORDER_CONFIRMED,
  BENEFITS,
  REDEEM_VOUCHERS,
} from '../text/text';
import {
  WHITE_BENEFITS,
  WHITE_DEALS,
  WHITE_REDEEM_VOUCHERS,
  ORDER_CONFIRMED_ACTIVE_ICON,
  ORDER_CONFIRMED_STEP_ICON,
  BENEFITS_ACTIVE_ICON,
  BENEFITS_STEP_ICON,
  DEALS_ACTIVE_ICON,
  DEALS_STEP_ICON,
  REDEEM_VOUCHER_STEP_ICON,
  REDEEM_VOUCHER_ACTIVE_ICON,
} from './images';

export const SECOND_CHECKOUT_STEPS = [
  {
    activeIcon: ORDER_CONFIRMED_ACTIVE_ICON[process.env.NEXT_PUBLIC_BRAND],
    forwardStepIcon: WHITE_DEALS[process.env.NEXT_PUBLIC_BRAND],
    isDeal: false,
    size: '18',
    stepIcon: ORDER_CONFIRMED_STEP_ICON[process.env.NEXT_PUBLIC_BRAND],
    title: ORDER_CONFIRMED,
  },
  {
    activeIcon: BENEFITS_ACTIVE_ICON[process.env.NEXT_PUBLIC_BRAND],
    forwardStepIcon: WHITE_BENEFITS[process.env.NEXT_PUBLIC_BRAND],
    isDeal: false,
    size: '14',
    stepIcon: BENEFITS_STEP_ICON[process.env.NEXT_PUBLIC_BRAND],
    title: BENEFITS[process.env.NEXT_PUBLIC_BRAND],
  },
  {
    activeIcon: DEALS_ACTIVE_ICON[process.env.NEXT_PUBLIC_BRAND],
    forwardStepIcon: WHITE_DEALS[process.env.NEXT_PUBLIC_BRAND],
    isDeal: true,
    size: '14',
    stepIcon: DEALS_STEP_ICON[process.env.NEXT_PUBLIC_BRAND],
    title: DEALS,
  },
  {
    activeIcon: REDEEM_VOUCHER_ACTIVE_ICON[process.env.NEXT_PUBLIC_BRAND],
    forwardStepIcon: WHITE_REDEEM_VOUCHERS[process.env.NEXT_PUBLIC_BRAND],
    isDeal: false,
    size: '14',
    stepIcon: REDEEM_VOUCHER_STEP_ICON[process.env.NEXT_PUBLIC_BRAND],
    title: REDEEM_VOUCHERS[process.env.NEXT_PUBLIC_BRAND || BRAND_WOWCHER],
  },
];
